<!-- Wrapper muss flex-column sein, damit der Body den Restplatz bekommt -->
<div class="flex flex-col h-full min-h-0">
  <!-- Header bleibt fix -->
    <div #title class="font-bold uppercase text-surface-900 mb-4" style="font-size: 18px;">
      {{ widgetHeader() }}
    </div>

  <!-- Body scrollt (alles darin) -->
  <div class="flex-1 min-h-0 overflow-y-auto">
    <!--<app-system-state></app-system-state>-->
    <app-invites></app-invites>

    <div *ngIf="hasInvites()" class="section-divider">
      <span class="section-divider__label">News</span>
    </div>

    <app-news></app-news>

    <ng-container *ngFor="let type of activityTypes">
      <ng-container [ngSwitch]="type">
        <app-other-activities *ngSwitchCase="ActivityType.OtherComponent"></app-other-activities>
      </ng-container>
    </ng-container>
  </div>
</div>
